export class AppConfig {
  static HostLoginName: string[] = ["boxoftech@server.office", "chandru@server.office"];
  PlatformID: string = "";
  apiBaseUrl: string = "";
  ServerUrl: string = "";
  Username: string = "";
  Password: string = "";
  LoginURL: string = "";
}
